import { createElement, ReactElement, useEffect } from "react";
import { IAppBarState } from "../Hooks/AppBarContext";
import "./Page.scss"
import { appSettings } from "../AppSettings";
import { setClass } from "../Utils";
import { DeviceOrientation, isNativeDevice } from "../Platform";
import { checkVersionAsync } from "../Services/VersionCheck";
import { useOperation } from "../Hooks/OperationContext";


const pages: IPage[] = [];

type PageContainer = (props: { content: IPage }) => ReactElement;

export interface IPage {
    name: string;
    title: string;
    route: string;
    icon?: React.ReactNode
    content: React.ReactNode,
    container?: PageContainer,
    isEnabled?: () => boolean;
    appBar?: IAppBarState;
}

interface IPageProps {
    value: IPage;
    container?: PageContainer;
}

export function Page(props: IPageProps) { 

    const operation = useOperation();

    useEffect(() => {

        if (isNativeDevice()) {
            try {
                nativeDevice.setOrientation(
                    appSettings.invertDisplay ?
                        DeviceOrientation.REVERSE_PORTRAIT :
                        DeviceOrientation.PORTRAIT);
            }
            catch (e) {
                console.error(e);
            }
        }
        else
            setClass(document.body, "reverse", appSettings.invertDisplay);

    }, [appSettings.invertDisplay]);

    /*
    useEffect(() => {
        checkVersionAsync(operation);
    }, []);
    */


    if (props.value.container && props.container?.name !== props.value.container?.name) {
        const container = createElement(props.value.container, { content: props.value, key: props.value.name });
        return container;
    }

    return (
        <div className={"page " + props.value.name}>
            {props.value.content}
        </div>
    );
}

export function registerPage(page: IPage) {
    pages.push(page);
}